import styled from 'styled-components';

export const JackpotBetsOptinReminderLogoDefaultBox = styled.div`
    width: 240px;
    height: 67px;

    background-size: 100%;
    background-position-y: 63%;
    margin-right: 8px;
    background-repeat: no-repeat, no-repeat;
    background-image: url(${props => props.theme.assets.images.jackpot_bet.jackpot_bet_logo_png.toString()});
`;